<template>
  <KDialog ref="dialog" v-model="show" title="服务授权" :ok="ok">
    <p class="mb-[16px]">
      <b>
        下方是系统创建的供容器服务2.0（KCE2.0）使用的角色，授权后容器服务拥有您的{{
          resourceName
        }}云资源访问权限
      </b>
    </p>

    <div class="bg-[#f5f5f9] p-[16px] mb-[16px]">
      <p class="mb-[16px]">角色名称：{{ roleName }}</p>
      <p class="mb-[16px]">
        描述：<slot name="desc"
          >容器服务2.0（KCE2.0）在应用运行时默认使用此角色来访问{{ resourceName }}云资源</slot
        >
      </p>
      <p class="m-0">
        权限描述：<slot name="permission-desc"
          >用于容器服务2.0（KCE2.0）{{ resourceName }}角色的授权策略</slot
        >
      </p>
    </div>

    <Tip type="warning" :showIcon="true">
      <span>如需修改角色权限，请前往</span>
      <a href="https://uc.console.ksyun.com/pro/iam/#/role/list/manage" target="_blank">角色管理</a>
      <span>中设置，需要注意的是，错误的配置可能导致容器服务2.0无法获取必要的权限</span>
    </Tip>
  </KDialog>
</template>

<script lang="ts" setup>
import type { PropType } from "vue";
import { Dialog as KDialog, Tip } from "@king-design/vue";
import * as vueTypes from "vue-types";
import { ref } from "vue";

defineProps({
  resourceName: vueTypes.string().isRequired,
  roleName: vueTypes.string().isRequired,
  ok: {
    type: Function as PropType<() => Promise<void>>,
    default: undefined,
  },
});

const show = defineModel("open", {
  required: true,
});
const dialog = ref();

defineExpose({
  showLoading: () => dialog.value.showLoading(),
  hideLoading: () => dialog.value.hideLoading(),
});
</script>
